import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './button.html',
})
export class ButtonComponent {
  type = input<string>('submit');
  disabled = input<boolean>(false);
  variant = input<'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary' | 'sexenary'>(
    'primary',
  );
  text = input<string>('');
  loading = input<boolean>(false);
  iconSrc = input<string>('');
  iconName = input<string>('');
  py = input<string>('4');

  public variantStyles: Record<string, string> = {
    primary: 'bg-th-blue border-[0.5px] border-th-blue text-white',
    secondary: 'bg-white text-th-blue border-[0.5px] border-th-blue',
    tertiary: 'bg-white text-th-blue border-[0.5px] border-th-light-blue',
    quaternary: 'bg-th-blue-highlight text-white border-[0.5px] border-th-blue-highlight',
    quinary: 'bg-th-orange text-th-black border-[0.5px] border-th-orange',
    sexenary: 'bg-th-light-blue text-th-black border-[0.5px] border-th-light-blue',
  };

  public iconColorStyles: Record<string, string> = {
    primary: 'text-white',
    secondary: 'text-th-blue',
    tertiary: 'text-th-blue',
    quaternary: 'text-white',
    quinary: 'text-th-black',
    sexenary: 'text-th-black',
  };
}
